import React, {useEffect} from 'react';
import "../assets/Campaigns.scss";
import {Grid} from "@deere/fuel-react";
import {useOktaAuth} from '@okta/okta-react';
import {CampaignTitleCard} from "./CampaignTitleCard";
import {CampaignCriteriaCard} from "./CampaignCriteriaCard";
import {CampaignStakeholderCard} from './CampaignStakeholderCard';
import PropTypes from "prop-types";

export const CampaignPublish = ({currentData, control, onSelectStep}) => {
    const {authState} = useOktaAuth();
    useEffect(() => {
        onSelectStep(4);
        return () => {
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    return (
        <Grid container>
            <CampaignTitleCard currentData={currentData} control={control} isPublish={true}/>
            <CampaignCriteriaCard currentData={currentData} control={control} isPublish={true}/>
            <CampaignStakeholderCard currentData={currentData} isPublish={true}/>
        </Grid>
    )
}

CampaignPublish.propTypes = {
  control: PropTypes.any,
  currentData: PropTypes.any,
  onSelectStep: PropTypes.func
}
